import React, { useState } from 'react';
import { useAuth } from '../auth';
import TabSalesMate from '../components/coperture/TabSalesMate';
import TabSitoTim from '../components/coperture/TabSitoTim';
import TabProiezione from '../components/coperture/TabProiezione';
import './coperture.css';

/* Dashboard Copertura: le due fonti (SalesMate e sito TIM) in un posto solo, più la
   proiezione di quello che l'agente dovrà verificare.

   Prima erano due pagine separate — «Copertura SSMATE» e «AI Copertura TIM» — che
   rispondevano alla stessa domanda da due parti diverse del menu. Ogni tab resta gatata
   dal suo permesso: chi ne ha uno solo vede una tab sola, non una pagina mutilata. */

const TABS = [
  { id: 'sm', label: 'SalesMate', perm: 'ssmate_copertura' },
  { id: 'tim', label: 'Sito TIM', perm: 'agente_copertura' },
  { id: 'proi', label: 'Proiezione', perm: 'agente_copertura' },
];

export default function CoperturePage() {
  const { can } = useAuth();
  const visibili = TABS.filter((t) => can(t.perm));
  const [tab, setTab] = useState(visibili[0]?.id || 'sm');
  const attiva = visibili.find((t) => t.id === tab) ? tab : visibili[0]?.id;

  return (
    <div className="cop">
      <div className="cop-head">
        <div>
          <h1>Copertura</h1>
          <p className="cop-sub">Vendibilità SalesMate e copertura dal sito TIM, con la proiezione delle verifiche in arrivo.</p>
        </div>
        {visibili.length > 1 && (
          <div className="cop-tabs">
            {visibili.map((t) => (
              <button key={t.id} className={`cop-tab${attiva === t.id ? ' on' : ''}`} onClick={() => setTab(t.id)}>
                {t.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {attiva === 'sm' && <TabSalesMate />}
      {attiva === 'tim' && <TabSitoTim />}
      {attiva === 'proi' && <TabProiezione />}
      {!attiva && <div className="cop-empty">Nessuna sezione della copertura abilitata per il tuo utente.</div>}
    </div>
  );
}
